import { Component, Renderer2 } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { CallBackService } from "src/app/features/pages/callback/services/CallBack.service";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";
import { RoleService } from "../../services/Role.service";
import { UpdateRoleResponse } from "../../models/UpdateRoleResponse";
import { ViewDTO } from "src/app/features/shared/models/Views/ViewDTO";
import { PermissionDTO } from "src/app/features/shared/models/Permissions/PermissionDTO";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-roles-update',
  templateUrl: './roles-update.component.html',
  styleUrls: ['./roles-update.component.css']
})
export class RolesUpdateComponent {

  public formGroup: FormGroup;
  public id: string;
  rolName : string;
  rolDescription : string;

  public viewList: ViewDTO[];
  public permissionList: { permission: string, checked: boolean }[] = [];

  vinDirectAssignPermission: PermissionDTO = null;
  hasVinDirectAssignPermission: boolean = false;
  
  public submitData: { Id: string, RoleName: string, ShortName: string, RoleDescription: string, Status:string, ViewsRole: any[] , permissionsRole: any[], ClientId : string};
  public clientes: { id: string, name: string }[] = [];
  readonly: boolean = true;
  _isVinsSelected: boolean;
  _stringIdentifiers: string ="";
  click = false;

  subscription_getUpdateRole: Subscription;
  subscription_postUpdateRole: Subscription;

  constructor(
    private sessionService: SessionService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private notifyService: SwalNotificationService,
    private routerService: Router,
    private route: ActivatedRoute,
    private callbackService: CallBackService
  ) {
    this._isVinsSelected = false;
  }

  ngOnInit(): void {
    this.sessionService.setIsExternalMap(false);
    this.id = this.route.snapshot.queryParamMap.get("Id");
    if(!environment.production) console.log('id',this.id);
    
    this.getUpdateRole();
    this.bulidForm();
    this.readonly = true;
  }
  ngOnDestroy() {
    if (this.subscription_getUpdateRole) 
      this.subscription_getUpdateRole.unsubscribe();
    if (this.subscription_postUpdateRole) 
      this.subscription_postUpdateRole.unsubscribe();
  }
  getUpdateRole() {
    this.subscription_getUpdateRole = this.roleService.getUpdateRole(this.id).subscribe({
      next: (data) => {
        if (data.isSuccess) {
          const resp = data.result as UpdateRoleResponse;
          if(!environment.production) console.log('data',data.result);
          // this.viewList = resp.viewsPermissions;

          this.viewList = resp.viewsPermissions.map(view => {
            const filteredPermissions = view.availablePermissions.filter(permission => {
              if (permission.name.includes("Asigna") && permission.name.includes("VIN")) {
                this.vinDirectAssignPermission = permission;
                this.hasVinDirectAssignPermission = true;
                return false;
              }
              return true;
            });
            
            return {
              ...view,
              availablePermissions: filteredPermissions
            };
          });
          this.viewList.sort((a, b) => a.idOrder - b.idOrder);
          this.clientes = resp.customers.map((x) => {
            return { id: x.clientId, name: x.description };
          });
          if(!environment.production) console.log('viewList',this.viewList, 'clientes',this.clientes);
          
          this.formGroup.controls["rolName"].patchValue(
            resp.roleName
          );
          this.formGroup.controls["rolShortName"].patchValue(
            resp.shortName
          );
          this.formGroup.controls["rolDescription"].patchValue(
            resp.roleDescription
          );

          if (this.hasVinDirectAssignPermission) {
            this.formGroup.addControl("vinDirectAssign", this.formBuilder.control(this.vinDirectAssignPermission.isActive));
          }

          if (resp.clientId != null) {
            this.formGroup.controls["client"].patchValue(
              resp.clientId
            );
          }
        }else{
          console.error('Error al obtener rol para actualizar', data.message, data.result);
          Sentry.captureMessage('RolesUpdate.getUpdateRole: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener rol para actualizar', error);
      }
    });
  }

  bulidForm() {
    this.formGroup = this.formBuilder.group({
      rolName: ["", Validators.required],
      rolShortName: ["", Validators.required],
      client: [""],
      rolDescription: [""],
      viewList: [[]],
    });
  }

  public onSubmit(rol: any) {
    if(!environment.production) console.log('rol',rol);
    
    if (rol.rolName != null && typeof (rol.rolName === "string")){
      var client = rol.client == null ? "" : rol.client;
      var checkedViews = this.viewList.filter(x => x.isActive == true);
      var checkedPermission = checkedViews.map(x => x.availablePermissions.filter(y => y.isActive == true)).reduce((accumulator, currentValue) => accumulator.concat(currentValue), []);
      if (this.hasVinDirectAssignPermission && this.vinDirectAssignPermission && rol && rol.vinDirectAssign) {
        this.vinDirectAssignPermission.isActive = rol.vinDirectAssign;
        checkedPermission.push(this.vinDirectAssignPermission);
      }
      this.submitData = { Id: this.id, RoleName: rol.rolName, ShortName:  rol.rolShortName, RoleDescription: rol.rolDescription, ViewsRole: checkedViews, permissionsRole: checkedPermission, Status: "Activo", ClientId: client};
      
      if(!environment.production) console.log('submitData',this.submitData);
      
      this.subscription_postUpdateRole = this.roleService.postUpdateRole(this.submitData).subscribe({
        next: (data) => {
          if (data.isSuccess) {
            this.notifyService.MessageSuccessful(
              "Rol Modificado Exitosamente",
              "El rol fue modificado exitosamente"
            );
            this.routerService.navigate(["/settingsAdmin"]);
          } else {
            this.notifyService.MessageError(
              data.result
            );
            Sentry.captureMessage('RolesUpdate.postUpdateRole: isSuccess false', { level: 'warning', extra: { response: data } });
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al actualizar rol:', error);
          this.notifyService.MessageError("Error al actualizar el rol, contacte con el administrador");
        }
      });
    }
    this.submitData = { Id: "", RoleName: "", ShortName: "",RoleDescription: "", ViewsRole: [] , permissionsRole: [], Status: "", ClientId: ""};
  }

  public getError(controlName: string): string {
    let error = "";
    const control = this.formGroup.get(controlName);
    if (control?.touched && control?.errors != null) {
      if (control?.errors?.["required"]) error = "Campo Requerido *";
      else if (control?.errors?.["email"]) error = "Introduzca un email válido *";
      else if (control?.errors?.["minLength"]) error = "Minimo 8 digitos *";
      else error = JSON.stringify(control.errors);
    }
    return error;
  }

  selectView(view: any){
    view.isActive = !view.isActive;
    view.availablePermissions.forEach(permission => {
      permission.isActive = true;
    });
    if(!environment.production) console.log('help',view.isActive);
  }
}
